import { useEffect, useState } from "react";
import { api, errMsg } from "../lib/api";
import type { SessionInfo } from "../state/store";
import { GateCard } from "./GateCard";
import { Onboard } from "./Onboard";

interface InviteInfo {
  email: string;
  name: string;
  vaultName: string;
  perm: "view" | "edit" | "add";
}

/** /invite#<token>: look the invite up, then run account set-up. */
export function Invite({ token, onDone }: { token: string; onDone: (s: SessionInfo) => void }) {
  const [info, setInfo] = useState<InviteInfo | null>(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!token) {
      setErr("This invite link is incomplete. Copy the whole link from the email and try again.");
      return;
    }
    api<InviteInfo>(`/invites/${encodeURIComponent(token)}`)
      .then(setInfo)
      .catch((e) => setErr(errMsg(e)));
  }, [token]);

  if (info) return <Onboard mode={{ kind: "invite", token, ...info }} onDone={onDone} />;
  return (
    <GateCard eyebrow="Shared by Agile Software" title={err ? "This invite can't be used" : "Checking your invite…"} sub={err || " "}>
      {err ? (
        <a href="/" style={{ fontWeight: 600, fontSize: 13 }}>
          Go to unlock
        </a>
      ) : null}
    </GateCard>
  );
}
